import styles from "./PortfolioInfos.module.scss";
import React, {useState} from "react";
import useFormat from "../../../util/useFormat";
import {useTranslation} from "react-i18next";
import ColoredAmount from "../../../common/ColoredAmount";
import Button from "../../../common/Button";
import {useNavigate} from "react-router";
import {useSelector} from "react-redux";
import {appConfigSelector} from "../../../slices/appSlice";
import {round} from "../../../util/util";

export const PortfolioInfos = ({quotes}) => {
  const {portfolioCurrency} = useSelector(appConfigSelector);
  const {formatAmount, formatNumber} = useFormat();
  const {t} = useTranslation("portfolio");

  const initialValue = Object.values(quotes).reduce((a, b) => a + b.initialValue, 0);
  const dayOpenValue = Object.values(quotes).reduce((a, b) => a + b.dayOpenValue, 0);
  const marketValue = Object.values(quotes).reduce((a, b) => a + b.marketValue, 0);
  const dayGains = Object.values(quotes).reduce((a, b) => a + b.dayGains, 0);
  const ongoingGains = Object.values(quotes).reduce((a, b) => a + b.ongoingGains, 0);

  let dayGainsDisplay = "-";
  let ongoingGainsDisplay = "-";

  if (marketValue > 0) {
    const dayGainsSign = marketValue > dayOpenValue ? "+" : "";
    const ongoingGainsSign = marketValue > ongoingGains ? "+" : "";

    const dayGainsPct = dayGainsSign + formatNumber(round((marketValue / dayOpenValue * 100) - 100, 2));
    const ongoingGainsPct = ongoingGainsSign + formatNumber(round((marketValue / initialValue * 100) - 100, 2));

    dayGainsDisplay = formatAmount(dayGains, portfolioCurrency) + " (" + dayGainsPct + "%)";
    ongoingGainsDisplay = formatAmount(ongoingGains, portfolioCurrency) + " (" + ongoingGainsPct + "%)";
  }

  return <div className={styles.toolbar}>
    <div className={styles.toolbarLeft}>
      <div className={styles.stat}>
        <div className={styles.statName}>{t("stat_total_value")}</div>
        <div className={styles.statValue}>
          {formatAmount(marketValue, portfolioCurrency)}
        </div>
      </div>

      <div className={styles.stat}>
        <div className={styles.statName}>{t("stat_day_gains")}</div>
        <div className={styles.statValue}>
          <ColoredAmount amount={dayGains}>{dayGainsDisplay}</ColoredAmount>
        </div>
      </div>

      <div className={styles.stat}>
        <div className={styles.statName}>{t("stat_total_gains")}</div>
        <div className={styles.statValue}>
          <ColoredAmount amount={ongoingGains}>{ongoingGainsDisplay}</ColoredAmount>
        </div>
      </div>
    </div>

    <SearchSymbol/>
  </div>;
};

const SearchSymbol = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("portfolio");

  const [symbol, setSymbol] = useState("");

  const onSubmit = e => {
    e.preventDefault();

    if (symbol.trim().length === 0) {
      return;
    }

    navigate("/portfolio/" + symbol.toUpperCase());
  };

  return <form className={styles.toolbarRight} onSubmit={onSubmit}>
    <input type="text" placeholder={t("search_placeholder")} value={symbol} onChange={e => setSymbol(e.target.value)}/>

    <Button type="submit" variant="primary" disabled={symbol.trim().length === 0}>
      <span className="material-icons">search</span>
    </Button>
  </form>;
};
